export default "__VITE_ASSET__d1eba80e__"